import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, IconButton, styled } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ChartCarouselDateItem from "../../Components/ChartCarouselDateItem.jsx";

const SliderActionButton = styled(IconButton)(({ position, disabled }) => ({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    left: position === "left" ? "-40px" : null,
    right: position === "right" ? "-40px" : null,
    top: '16px',
    padding: '6px',
    pointerEvents: 'inherit !important',
    cursor: disabled ? 'not-allowed !important' : 'pointer !important',
    background: '#F3F5F7 !important',
    "& .MuiSvgIcon-root": {
        color: disabled ? "#B2B2B2" : '#000000',
        fontSize: "12px",
        marginLeft: 'auto',
        fontWeight: 500,
    },

    "& .MuiIconButton-root.Mui-disabled": {
        background: '#F3F5F7 !important'
    },
    "&:hover": {
        backgroundColor: "#D5D7FF",
        "& .MuiSvgIcon-root": {
            color: disabled ? 'inherit' : "#4D44D8",
        },
    },
}));


function CarouselSlider({ disabled, position, onClick }) {
    return (
        <SliderActionButton
            disabled={disabled}
            position={position}
            onClick={onClick}
        >
            {position === "left" ? <ArrowBackIosNewIcon /> : <ArrowForwardIosIcon />}
        </SliderActionButton>
    );
}

const SlickCarouselWithDateHighlight = ({
    Data,
    slidesToShow,
    setTheDate,
    actualDates,
    startDate,
    dataGapDates = [],
    shouldAnnotate = () => { return { shouldAnnotate: false, annotateColor: "#C8D1DA" } }
}) => {
    const sliderRef = React.createRef();
    const [activeSlide, setActiveSlide] = useState(0);
    const initialSlide = actualDates.findIndex((date) => date === startDate);
    const startIndexOfSlide = parseInt(initialSlide / slidesToShow) * slidesToShow;
    const [disablePreviousButton, setDisablePreviousButton] = useState(startIndexOfSlide === 0
    );
    const [disableNextButton, setDisableNextButton] = useState(
        startIndexOfSlide + slidesToShow >= actualDates.length
    );

    useEffect(() => {
        if (initialSlide >= 0 && initialSlide < Data.length) {
            sliderRef.current.slickGoTo(startIndexOfSlide);
        }
    }, [initialSlide, Data.length]);

    useEffect(() => {
        setDisablePreviousButton(activeSlide === 0);
        setDisableNextButton((activeSlide + slidesToShow) >= actualDates.length);
    }, [activeSlide, actualDates.length]);

    const settings = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: Data.length < slidesToShow ? Data.length : slidesToShow,
        slidesToScroll: Data.length < slidesToShow ? Data.length : slidesToShow,
        initialSlide: 0,
        beforeChange: (current, next) => setActiveSlide(next),
        centerMode: false,
        nextArrow: (
            <CarouselSlider position={"right"} disabled={disableNextButton} />
        ),
        prevArrow: (
            <CarouselSlider position={"left"} disabled={disablePreviousButton} />
        ),
    };
    return (
        <Box>
            <Slider {...settings} ref={sliderRef}>
                {Data.map((slide, index) => (
                    <ChartCarouselDateItem
                        key={index}
                        shouldHighlight={actualDates[index] === startDate}
                        annotate={shouldAnnotate(actualDates[index])}
                        shouldHighlightDataGap={dataGapDates.includes(actualDates[index])}
                        actualDate={actualDates[index]}
                        startDate={startDate}
                        onClick={setTheDate}
                        text={slide}
                    />

                ))}
            </Slider>
        </Box>
    );
};

export default SlickCarouselWithDateHighlight;
